export default __webpack_public_path__ + "56bb2cf5199fa199797bea80541590cf.svg";